<!-- 通用表单组件 -->
<template>
  <div>
    <el-table
      @sort-change="sortChange"
      @selection-change="handleSelectionChange"
      @select="handleSelectionChangeOne"
      @select-all="handleSelectionChangeAll"
      ref="table"
      :key="tableKey"
      :border="border"
      :row-class-name="tableRowClassName"
      :header-cell-style="header_style"
      :span-method="arraySpanMethod"
      :data="tableData"
      :show-summary="showSummary"
      :summary-method="getSummaries"
      fit
      :stripe="stripe"
      highlight-current-row
      style="width: 100%; z-index: 1"
      @row-dblclick="dblclick"
      :max-height="maxHeight || tableMaxHeight"
      v-loading="loading"
      :row-key="rowKey">
      <el-table-column
        v-if="checked"
        :selectable="checkSelectable"
        :reserve-selection="reserveSelection"
        type="selection"
        width="55px"
        align="center"
        key="checkedcheckedchecked"/>
      <el-table-column
        v-if="firstIndex"
        type="index"
        width="55px"
        align="center"
        label="序号"
        key="firstIndexfirstIndexfirstIndex"/>
      <el-table-column
        v-if="firstIndexOne"
        type="index"
        width="55px"
        align="center"
        label="S/N"
        :fixed="true"
        key="firstIndexOnefirstIndexOnefirstIndexOne"/>
      <template v-for="(column, index) in getColumns(columns)">
      <el-table-column
        v-if="checkAccount(column.account) && checkPermission(column.code, $route.meta.buttonCodes)"
        :key="column.prop"
        :sortable="column.sort === false ? false : sortable"
        :prop="column.prop"
        :min-width="column.width ? `${column.width}px` : '80px'"
        :label="column.label"
        :fixed="column.fixed"
        :class="{ template: column.prop === 'template' }"
        :class-name="column.class !== undefined ? column.class : ''"
        :align="column.align || 'center'"
        :show-overflow-tooltip=getToolTip(column)
        :resizable=" noResizable.includes(column.type)?false:true">
        <template slot="header">
          <el-tooltip v-if="column.type === 'checkbox'" content="是否在采购订单合同唛头备注中显示英文品名" placement="top">
            <el-button
                type="text" @click="() => handleSelectAll(column)">
              {{column.label + otherTxt}}
            </el-button>
          </el-tooltip>
        </template>
        <template slot="header">
          <span>{{column.label}}</span>
          <el-tooltip v-if="column.type === 'icon_tooltip'" :content=" column.iconTooltipContent" placement="top">
            <i class="el-icon-question" style="color: #E6A23C"></i>
          </el-tooltip>
        </template>
        <template slot-scope="scope">
          <template v-if="column.type === 'custom'">
            <slot :name="column.slot" :row="scope.row" :prop="column.prop" :$index="scope.$index"></slot>
          </template>
          <template v-if="column.type === 'checkbox'">
            <el-checkbox v-model="scope.row[column.prop]"></el-checkbox>
          </template>
          <template v-if="column.type === 'IMG'">
            <el-image
              v-if="scope.row[column.prop]"
              style="max-width: 70px; max-height: 50px"
              :src="scope.row[column.prop]"
              :preview-src-list="[scope.row[column.prop]]"
            ></el-image>
            <span v-else></span>
          </template>
          <template v-else-if="column.type === 'pic_title'">
            <el-image
              class="m-r-12"
              v-if="scope.row[column.prop]"
              style="width: 50px; height: 50px"
              :src="scope.row[column.prop]"
              :preview-src-list="[scope.row[column.prop]]"
            ></el-image>
            <div class="line-1 w100">
              {{
                scope.row[column.prop2] === 0
                  ? 0
                  : scope.row[column.prop2] || ""
              }}
            </div>
          </template>
          <!-- 报关开票管理开票资料号码列 -->
          <template v-else-if="column.key === 'code' && column.type === 'invoiceCode'">
            <img
                v-if="
                column.left_icon &&
                scope.row[column.left_icon_key]"
                class="w-35 h-35 icon"
                :src="column.left_icon"
                alt=""/>
            <el-popover
                v-if="
                column.right_icon &&
                scope.row[column.right_icon_key] &&
                column.right_icon_content"
                placement="top-start"
                width="300"
                trigger="hover"
                :content="`原报关合同号：${scope.row[column.right_icon_content] || ''}`">
              <img slot="reference" class="w-35 h-35 right-top" :src="column.right_icon" alt=""/>
            </el-popover>
            <span>
              {{scope.row[column.prop] === 0 ? 0 : scope.row[column.prop] || "" }}
            </span>
            <div
                v-if="scope.row[column.changeState] && scope.row[column.changeState]?.code === 0"
                class="content-bottom"
                style="width: 100%;height: 18px;background-color: #ff9e31;cursor: pointer"
                @click="handleFunNameClick(column.click, scope)">
              <span>空（点击查看原资料）</span>
            </div>
            <div
                v-if="scope.row[column.changeState] && scope.row[column.changeState]?.code === 1"
                class="content-bottom"
                style="width: 100%;height: 18px;background-color: #0f8b61;cursor: pointer"
                @click="handleFunNameClick(column.click, scope)">
              <span>被替换（点击查看原资料）</span>
            </div>
            <div
                v-if="scope.row[column.changeState] && scope.row[column.changeState]?.code === 2"
                class="content-bottom"
                style="width: 100%;height: 18px;background-color: #5ea9dc;cursor: pointer"
                @click="handleFunNameClick(column.click, scope)">
              <span>无合同（点击查看原资料）</span>
            </div>
          </template>
          <template
            v-else-if="column.key === 'sn' && column.type !== 'sn-popver'"
          >
            <img
              v-if="
                scope.row[column.icon_key4] &&
                scope.row[column.icon_key4] === column.icon_value4 &&
                column.icon4 &&
                scope.row[column.icon_key4_1] &&
                scope.row[column.icon_key4_1] === column.icon_value4_1
              "
              slot="reference"
              class="w-40 h-40 icon"
              :src="column.icon4"
              alt=""
            />
            <img
              v-else-if="
                scope.row[column.icon_key5] &&
                scope.row[column.icon_key5] === column.icon_value5 &&
                column.icon5 &&
                scope.row[column.icon_key5_1] &&
                scope.row[column.icon_key5_1] === column.icon_value5_1
              "
              class="w-40 h-40 icon"
              :src="column.icon5"
              alt=""
            />
            <img
              v-else-if="
                scope.row[column.icon_key] &&
                scope.row[column.icon_key] === column.icon_value &&
                column.icon
              "
              class="w-40 h-40 icon"
              :src="column.icon"
              alt=""
            />
            <img
              v-else-if="
                scope.row[column.icon_key2] &&
                scope.row[column.icon_key2] === column.icon_value2 &&
                column.icon2
              "
              class="w-40 h-40 icon"
              :src="column.icon2"
              alt=""
            />
            <img
              v-else-if="
                scope.row[column.icon_key3] &&
                scope.row[column.icon_key3] === column.icon_value3 &&
                column.icon3
              "
              class="w-40 h-40 icon"
              :src="column.icon3"
              alt=""
            />
            <img
              v-else-if="
                scope.row[column.icon_key4] && scope.row[column.icon_key4] === column.icon_value4 && column.icon4
              "
              class="w-40 h-40 icon"
              :src="column.icon4"
              alt=""
            />
            <span>
              {{
                scope.row[column.prop] === 0 ? 0 : scope.row[column.prop] || ""
              }}
            </span>
          </template>
          <template
            v-else-if="column.key === 'sn' && column.type === 'sn-popver'"
          >
            <el-popover
              v-if="
                scope.row[column.icon_key4] &&
                scope.row[column.icon_key4] === column.icon_value4 &&
                column.icon4 &&
                scope.row[column.icon_key4_1] &&
                scope.row[column.icon_key4_1] === column.icon_value4_1 &&
                column.content4
              "
              placement="top-start"
              width="100"
              trigger="hover"
              :content="column.content4"
            >
              <img
                slot="reference"
                class="w-40 h-40 icon"
                :src="column.icon4"
                alt=""
              />
            </el-popover>
            <el-popover
              v-else-if="
                scope.row[column.icon_key5] &&
                scope.row[column.icon_key5] === column.icon_value5 &&
                column.icon5 &&
                scope.row[column.icon_key5_1] &&
                scope.row[column.icon_key5_1] === column.icon_value5_1 &&
                column.content5
              "
              placement="top-start"
              width="100"
              trigger="hover"
              :content="column.content5"
            >
              <img
                slot="reference"
                class="w-40 h-40 icon"
                :src="column.icon5"
                alt=""
              />
            </el-popover>
            <el-popover
              v-else-if="
                scope.row[column.icon_key] &&
                scope.row[column.icon_key] === column.icon_value &&
                column.icon &&
                column.content
              "
              placement="top-start"
              width="100"
              trigger="hover"
              :content="column.content"
            >
              <img
                slot="reference"
                class="w-40 h-40 icon"
                :src="column.icon"
                alt=""
              />
            </el-popover>
            <el-popover
              v-else-if="
                scope.row[column.icon_key2] &&
                scope.row[column.icon_key2] === column.icon_value2 &&
                column.icon2 &&
                column.content2
              "
              placement="top-start"
              width="100"
              trigger="hover"
              :content="column.content2"
            >
              <img
                slot="reference"
                class="w-40 h-40 icon"
                :src="column.icon2"
                alt=""
              />
            </el-popover>
            <el-popover
              v-else-if="
                scope.row[column.icon_key3] &&
                scope.row[column.icon_key3] === column.icon_value3 &&
                column.icon3 &&
                column.content3
              "
              placement="top-start"
              width="100"
              trigger="hover"
              :content="column.content3"
            >
              <img
                slot="reference"
                class="w-40 h-40 icon"
                :src="column.icon3"
                alt=""
              />
            </el-popover>
            <el-popover
                v-if="
                scope.row[column.icon_key6] &&
                scope.row[column.icon_key6] === column.icon_value6 &&
                column.icon6 &&
                scope.row[column.icon_key6_1] &&
                scope.row[column.icon_key6_1] === column.icon_value6_1 &&
                column.content6
              "
                placement="top-start"
                width="100"
                trigger="hover"
                :content="column.content6"
            >
              <img
                  slot="reference"
                  class="w-40 h-40 right-top"
                  :src="column.icon6"
                  alt=""
              />
            </el-popover>
             <el-popover
                v-if="
                scope.row[column.icon_key7] &&
                scope.row[column.icon_key7] === column.icon_value7 &&
                column.icon7 &&
                scope.row[column.icon_key7_1] &&
                scope.row[column.icon_key7_1] === column.icon_value7_1 &&
                column.content7
              "
                placement="top-start"
                width="100"
                trigger="hover"
                :content="column.content7"
            >
              <img
                  slot="reference"
                  class="w-40 h-40 right-top"
                  :src="column.icon7"
                  alt=""
              />
            </el-popover>
             <el-popover
                v-if="
                scope.row[column.icon_key8] &&
                scope.row[column.icon_key8] === column.icon_value8 &&
                column.icon8 &&
                scope.row[column.icon_key8_1] &&
                scope.row[column.icon_key8_1] === column.icon_value8_1 &&
                column.content8
              "
                placement="top-start"
                width="100"
                trigger="hover"
                :content="column.content8"
            >
              <img
                  slot="reference"
                  class="w-40 h-40 right-top"
                  :src="column.icon8"
                  alt=""
              />
            </el-popover>
             <el-popover
              v-else-if="
                scope.row[column.icon_key9] &&
                scope.row[column.icon_key9] === column.icon_value9 &&
                column.icon9 &&
                column.content9
              "
              placement="top-start"
              width="100"
              trigger="hover"
              :content="column.content9"
            >
              <img
                slot="reference"
                class="w-40 h-40 right-top"
                :src="column.icon9"
                alt=""
              />
             </el-popover>
            <span>
              {{
                scope.row[column.prop] === 0 ? 0 : scope.row[column.prop] || ""
              }}
            </span>
          </template>
          <!--code 增加角标-->
          <template v-else-if="column.key === 'code' && column.type === 'sn-popver'">
            <el-popover
                v-if="
                scope.row[column.icon_key] &&
                scope.row[column.icon_key] === column.icon_value &&
                column.icon &&
                scope.row[column.icon_key] &&
                scope.row[column.icon_key] === column.icon_value &&
                column.content
              "
                placement="top-start"
                width="100"
                trigger="hover"
                :content="column.content">
              <img slot="reference" class="w-40 h-40 icon" :src="column.icon" alt=""/>
            </el-popover>
            <span>
              {{scope.row[column.prop] === 0 ? 0 : scope.row[column.prop] || "" }}
            </span>
          </template>
          <!--          发票销售方名称 增加角标-->
          <template
              v-else-if="column.key === 'factoryName' && column.type === 'custom'"
          >
            <el-popover
                v-if="
                scope.row[column.icon_key] &&
                scope.row[column.icon_key] === column.icon_value &&
                column.icon &&
                scope.row[column.icon_key] &&
                scope.row[column.icon_key] === column.icon_value &&
                column.content
              "
                placement="top-start"
                width="100"
                trigger="hover"
                :content="scope.row[column.content]"
            >
              <img
                  slot="reference"
                  class="w-40 h-40 icon"
                  :src="column.icon"
                  alt=""
              />
            </el-popover>
          </template>
          <span
            :class="{
              'table-template': column.prop === 'template'
            }"
            v-else-if="column.slot">
            <slot
              :send="scope.row"
              :name="column.prop"
              :$index="scope.$index"/>
          </span>
          <!-- 状态 -->
          <span v-else-if="column.type === 'status'">
            <el-tag
              v-if="scope.row[column.prop]"
              :type="getType(scope.row[column.prop], column.typeList)">
              {{ scope.row[column.prop] | filterlistStatus(column.typeList) }}
            </el-tag>
          </span>
          <span v-else-if="column.type === 'disabled'">
            <el-tag :type="getType(scope.row[column.prop], column.typeList)">
              {{ scope.row[column.prop] | filterlistDisabled(column.typeList) }}
            </el-tag>
          </span>
          <span v-else-if="column.type === 'status_list'">
            <el-tag
              v-for="(it, i) in scope.row[column.prop]"
              :key="i"
              class="m-r-10"
            >
              {{ it | filterlistStatus(column.typeList) }}</el-tag
            >
          </span>
          <span v-else-if="column.type === 'boolean_status'">
            {{ scope.row[column.prop] ? column.trueTxt : column.falseTxt }}
          </span>
          <span v-else-if="column.type === 'tag'">
            <el-tag
              :style="
                'color:#fff;border:none; backgroundColor:' +
                scope.row[column.tag_key]
              "
            >
              {{ scope.row[column.prop] }}
            </el-tag>
          </span>
          <!-- 时间 -->
          <span v-else-if="column.type === 'time'">
            {{ scope.row[column.prop] | timeParser }}
          </span>
          <!-- 函数处理数据 -->
          <span v-else-if="column.render">
            {{
              column.render(scope.row[column.prop], scope.row) === 0
                ? 0
                : column.render(scope.row[column.prop], scope.row) || ""
            }}
          </span>
          <span v-else-if="column.prop === '_blank'" />
          <template v-else-if="column.type === 'link'">
            <div
              class="cursor"
              style="font-size: 14px;font-weight: 500;"
              :class="
                checkPermission(column.stop, $route.meta.buttonCodes)
                  ? 'main-color1'
                  : 'disabled-color'
              "
              @click="
                checkPermission(column.stop, $route.meta.buttonCodes)
                  ? handleLinkClick(scope, column.click)
                  : ''
              "
            >
              {{ scope.row[column.prop] }}
            </div>
          </template>
           <template v-else-if="column.type === 'linkWithState'">
            <div
              class="cursor"
              :class="
                checkPermission(column.stop, $route.meta.buttonCodes) && scope.row[column.typeNoKey] !== column.typeNoValue
                  ? 'main-color1'
                  : ''
              "
              @click="
                checkPermission(column.stop, $route.meta.buttonCodes)
                  ? handleLinkClick(scope)
                  : ''
              "
            >
              {{ scope.row[column.prop] }}
            </div>
          </template>
          <template v-else-if="column.type === 'noCheckLink'">
            <div
              class="cursor main-color1"
              style="font-size: 14px;font-weight: 500;"
              @click="handleLinkClick(scope)"
            >
              {{ scope.row[column.prop] }}
            </div>
          </template>
          <template v-else-if="column.type === 'spec_link'">
            <div
              class="main-color1 cursor"
              style="font-size: 14px;font-weight: 500;"
              @click="handleSpecLinkClick(scope, column)"
            >
              {{ scope.row[column.prop] }}
            </div>
          </template>
          <template v-else-if="column.type === 'link_popover_label_info_download'">
            <div
              class="cursor"
              :class="canClickDownloadLabelInfo(scope,column) ? 'main-color1' :'' "
              @click="showDownloadLabelInfo(scope,column)"
            >
              {{ scope.row[column.prop] }}
            </div>
          </template>
          <template v-else-if="column.type === 'arr'">
            <span
              class="m-r-15"
              v-for="(it, i) in scope.row[column.prop]"
              :key="i"
              >{{ it.label }}: {{ it.value }}</span
            >
          </template>
          <template v-else-if="column.type === 'discount'">
            <el-input
              style="width: 80px"
              v-if="column.isEdit"
              v-model="scope.row[column.prop]"
              @change="
                (val) => {
                  return changeInputValue(val, scope, column);
                }
              "
              :placeholder="column.placeholder || '请输入'"
              :maxlength="column.maxlength"
              :disabled="column.disabled"
            >
            </el-input>
            <span v-else>
              {{
                scope.row[column.prop] === 0 ? 0 : scope.row[column.prop] || ""
              }}
            </span>
            <span
              v-if="
                +scope.row[column.prop] !== +scope.row[column.key2] &&
                scope.row[column.key2]
              "
            >
              ({{
                scope.row[column.key2] === 0 ? 0 : scope.row[column.key2] || ""
              }})
            </span>
          </template>
          <template v-else-if="column.type === 'discountDisabled'">
            <span v-if="column.textViewKey2  && column.textViewValues2.includes(scope.row[column.textViewKey2])">{{scope.row[column.prop]}}</span>
            <span v-else-if="column.textViewKey  && column.textViewValues.includes(scope.row[column.textViewKey])">{{scope.row[column.prop]}}</span>
            <div v-else>
              <el-input
                  style="width: 80px"
                  v-if="column.isEdit"
                  v-model="scope.row[column.prop]"
                  @change="
                (val) => {
                  return changeInputValue(val, scope, column);
                }
              "
                  :placeholder="column.placeholder || '请输入'"
                  :maxlength="column.maxlength"
                  :disabled="scope.row[column.disabledKey] === column.value"
              >
              </el-input>
              <span v-else>
              {{
                  scope.row[column.prop] === 0 ? 0 : scope.row[column.prop] || ""
                }}
            </span>
              <span
                  v-if="
                +scope.row[column.prop] !== +scope.row[column.key2] &&
                scope.row[column.key2]
              "
              >
              ({{
                  scope.row[column.key2] === 0 ? 0 : scope.row[column.key2] || ""
                }})
            </span>
            </div>
          </template>
          <!-- 折后价：计价单位 > 1 时右侧展示警告 -->
          <template v-else-if="column.type === 'discountDisabledQuantityStep'">
            <div v-if="column.textViewKey2  && column.textViewValues2.includes(scope.row[column.textViewKey2])" class="discount-quantity-step-cell">
              <span v-if="column.textViewKey2  && column.textViewValues2.includes(scope.row[column.textViewKey2])">
                {{scope.row[column.prop]}}
              </span>
              <el-tooltip
                  v-if="shouldShowQuantityStepWarning(scope.row, column)"
                  effect="dark"
                  placement="top"
              >
                <div slot="content" class="quantity-step-warning-content">{{ getTooltipContent(scope.row, column) }}</div>
                <img src="@/assets/images/light_bulb.png" class="w-18 h-18" style="cursor: pointer" alt="">
              </el-tooltip>
            </div>
            <div v-else-if="column.textViewKey  && column.textViewValues.includes(scope.row[column.textViewKey])" class="discount-quantity-step-cell">
              <span>{{scope.row[column.prop]}}</span>
              <el-tooltip
                  v-if="shouldShowQuantityStepWarning(scope.row, column)"
                  effect="dark"
                  placement="top"
              >
                <div slot="content" class="quantity-step-warning-content">{{ getTooltipContent(scope.row, column) }}</div>
                <img src="@/assets/images/light_bulb.png" class="w-18 h-18" style="cursor: pointer" alt="">
              </el-tooltip>
            </div>
            <div v-else class="discount-quantity-step-cell">
              <el-input
                  style="width: 80px"
                  v-if="column.isEdit"
                  v-model="scope.row[column.prop]"
                  @change="
                (val) => {
                  return changeInputValue(val, scope, column);
                }
              "
                  :placeholder="column.placeholder || '请输入'"
                  :maxlength="column.maxlength"
                  :disabled="scope.row[column.disabledKey] === column.value"
              >
              </el-input>
              <span v-else>
              {{
                  scope.row[column.prop] === 0 ? 0 : scope.row[column.prop] || ""
                }}
              </span>
              <el-tooltip
                v-if="shouldShowQuantityStepWarning(scope.row, column)"
                effect="dark"
                placement="top"
              >
                <div slot="content" class="quantity-step-warning-content">{{ getTooltipContent(scope.row, column) }}</div>
                <img src="@/assets/images/light_bulb.png" class="w-18 h-18" style="cursor: pointer" alt="">
              </el-tooltip>
            </div>
          </template>
          <!-- 价格出现四位小数时右侧展示警告 -->
          <template v-else-if="column.type === 'price_warn'">
            <div class="discount-quantity-step-cell">
              <span>{{scope.row[column.prop]}} </span>
              <el-tooltip
                  v-if="hasMoreThanTwoDecimals(scope.row[column.prop])"
                  effect="dark"
                  placement="top"
              >
                <div slot="content" class="quantity-step-warning-content">{{ getTooltipContent(scope.row, column) }}</div>
                <i class="el-icon-warning input-multiple-of-warning" />
              </el-tooltip>
            </div>
          </template>
          <!-- 价格小数位 > 2 时右侧展示灯泡提示；isEdit 时可编辑 -->
          <template v-else-if="column.type === 'price_hint'">
            <div class="discount-quantity-step-cell">
              <el-input
                style="width: 80px"
                v-if="column.isEdit"
                v-model="scope.row[column.prop]"
                @change="
                  (val) => {
                    return changeInputValue(val, scope, column);
                  }
                "
                :placeholder="column.placeholder || '请输入'"
                :maxlength="column.maxlength"
                :disabled="column.disabled"
              >
              </el-input>
              <span v-else>{{scope.row[column.prop]}} </span>
              <el-tooltip
                  v-if="hasMoreThanTwoDecimals(scope.row[column.prop])"
                  effect="dark"
                  placement="top"
              >
                <div slot="content" class="quantity-step-warning-content">{{ getTooltipContent(scope.row, column) }}</div>
                <img src="@/assets/images/light_bulb.png" class="w-18 h-18" style="cursor: pointer" alt="">
              </el-tooltip>
            </div>
          </template>
          <!-- 数量不符合计价单位时右侧展示警告 -->
          <template v-else-if="column.type === 'step_warn'">
            <div class="discount-quantity-step-cell">
              <span>{{scope.row[column.prop]}} </span>
              <el-tooltip
                  v-if="shouldShowMultipleOfWarning(scope.row, column)"
                  effect="dark"
                  placement="top"
              >
                <div slot="content" class="quantity-step-warning-content">{{ getTooltipContent(scope.row, column) }}</div>
                <i class="el-icon-warning input-multiple-of-warning" />
              </el-tooltip>
            </div>
          </template>
          <!-- 输入框 -->
          <template v-else-if="column.type === 'input'">
            <el-form-item v-if="column.check"
                          :prop="`${column.check.prefix}.${scope.$index}.${column.prop}`"
                          :rules="column.check.rules">
              <el-input
                  v-model="scope.row[column.prop]"
                  @change="
                (val) => {
                  return changeInputValue(val, scope, column);
                }
              "
                  :placeholder="column.placeholder || '请输入'"
                  :maxlength="column.maxlength"
                  :disabled="column.disabled"
                  :readonly="column.readonly"
              >
              </el-input>
            </el-form-item>
            <el-input
                v-else
                v-model="scope.row[column.prop]"
                @change="
              (val) => {
                return changeInputValue(val, scope, column);
              }
            "
                :placeholder="column.placeholder || '请输入'"
                :maxlength="column.maxlength"
                :disabled="column.disabled"
            >
            </el-input>
          </template>
          <template v-else-if="column.type === 'inputDisabled'">
            <span v-if="column.textViewKey2  && column.textViewValues2.includes(scope.row[column.textViewKey2])">{{scope.row[column.prop]}}</span>
            <span v-else-if="column.textViewKey  && column.textViewValues.includes(scope.row[column.textViewKey])">{{scope.row[column.prop]}}</span>
            <el-input
              v-else
              v-model="scope.row[column.prop]"
              @change="
                (val) => {
                  return changeInputValue(val, scope, column);
                }
              "
              :placeholder="column.placeholder || '请输入'"
              :maxlength="column.maxlength"
              :disabled="column.disabledKey && column.disabledValue.includes(scope.row[column.disabledKey])"
            >
            </el-input>
          </template>
          <!-- 可编辑输入框，支持倍数校验提示 -->
          <template v-else-if="column.type === 'inputDisabledMultipleOf'">
            <span v-if="column.textViewKey2  && column.textViewValues2.includes(scope.row[column.textViewKey2])">{{scope.row[column.prop]}}</span>
            <span v-else-if="column.textViewKey  && column.textViewValues.includes(scope.row[column.textViewKey])">{{scope.row[column.prop]}}</span>
            <el-input
              v-else
              v-model="scope.row[column.prop]"
              @change="
                (val) => {
                  return changeInputValue(val, scope, column);
                }
              "
              :placeholder="column.placeholder || '请输入'"
              :maxlength="column.maxlength"
              :disabled="column.disabledKey && column.disabledValue.includes(scope.row[column.disabledKey])"
            >
              <template
                v-if="shouldShowMultipleOfWarning(scope.row, column)"
                slot="suffix"
              >
                <el-tooltip
                  effect="dark"
                  placement="top"
                  :content="getMultipleOfWarningContent(scope.row, column)"
                >
                  <i class="el-icon-warning input-multiple-of-warning" />
                </el-tooltip>
              </template>
            </el-input>
          </template>
          <!-- 数字输入 -->
          <template v-else-if="column.type === 'inputNumber'">
            <el-form-item v-if="column.check"
                          :prop="`${column.check.prefix}.${scope.$index}.${column.prop}`"
                          :rules="column.check.rules">
              <el-input-number
                @change="
                  (val) => {
                    return changeInputValue(val, scope, column);
                  }
                "
                v-model="scope.row[column.prop]"
                :placeholder="column.placeholder || '请输入'"
                :min="getNumberLimit(column.min, scope.row, column.minProp, 0)"
                :max="getNumberLimit(column.max, scope.row, column.maxProp, 9999999)"
                :disabled="column.disabled || scope.row[column['_disabled']] || false"
                :controls="column.controls || false"
                :precision="column.precision || 0"
              >
              </el-input-number>
            </el-form-item>
            <el-input-number
                v-else
                @change="
                  (val) => {
                    return changeInputValue(val, scope, column);
                  }
                "
                v-model="scope.row[column.prop]"
                :placeholder="column.placeholder || '请输入'"
                :min="getNumberLimit(column.min, scope.row, column.minProp, 0)"
                :max="getNumberLimit(column.max, scope.row, column.maxProp, 9999999)"
                :disabled="column.disabled"
                :controls="column.controls || false"
                :precision="column.precision || 0"
              >
            </el-input-number>
          </template>
          <template v-else-if="column.type === 'inputNumberSelect'">
            <el-input-number
              @change="
                (val) => {
                  return changeInputValue(val, scope, column);
                }
              "
              v-model="scope.row[column.prop]"
              :placeholder="column.placeholder || '请输入'"
              :min="getNumberLimit(column.min, null, null, 0)"
              :max="getNumberLimit(column.max, scope.row, column.maxProp, 9999999)"
              :disabled="!scope.row.selectable"
              :controls="column.controls || false"
              :precision="column.precision || 0"
            >
            </el-input-number>
          </template>
          <!-- 文本框 -->
          <template v-else-if="column.type === 'textarea'">
            <el-input
              type="textarea"
              :maxlength="column.maxlength"
              :rows="column.rows || 2"
              v-model="scope.row[column.prop]"
              :placeholder="column.placeholder || '请输入'"
              :disabled="column.disabled"
              :readonly="column.readonly"
            ></el-input>
          </template>
          <!-- 选择框 -->
          <template v-else-if="column.type === 'select'">
            <el-select
              :multiple="column.multiple"
              :collapse-tags="column.collapseTags"
              v-model="scope.row[column.prop]"
              :clearable="!!column.clearable"
              :filterable="!!column.filterable"
              :placeholder="column.placeholder || '请选择'"
              :remote="column.remote || false"
              :remote-method="column.remote_method"
              @visible-change="(val) => visibleChange(val, scope, column)"
              @change="
                (val) => {
                  return changeValue(val, scope, column);
                }
              "
            >
              <el-option
                v-for="(item, index) in column.options"
                :key="index"
                :label="
                  (column.resetKey && item[column.resetKey.label]) || item.label
                "
                :value="
                  (column.resetKey && item[column.resetKey.value]) || item.value
                "
              />
            </el-select>
          </template>
          <template v-else-if="column.type === 'selectDisabled'">
            <span v-if="column.textViewKey2  && column.textViewValues2.includes(scope.row[column.textViewKey2])">{{scope.row[column.prop]}}</span>
            <span v-else-if="column.textViewKey  && column.textViewValues.includes(scope.row[column.textViewKey])">{{scope.row[column.prop]}}</span>
            <el-select
              v-else
              :multiple="column.multiple"
              :collapse-tags="column.collapseTags"
              v-model="scope.row[column.prop]"
              :clearable="!!column.clearable"
              :filterable="!!column.filterable"
              :placeholder="column.placeholder || '请选择'"
              :remote="column.remote || false"
              :remote-method="column.remote_method"
              :disabled="column.disabledValue && column.disabledValue.includes(scope.row[column.disabledKey])"
              @change="
                (val) => {
                  return changeValue(val, scope, column);
                }
              "
            >
              <el-option
                v-for="(item, index) in column.options"
                :key="index"
                :label="
                  (column.resetKey && item[column.resetKey.label]) || item.label
                "
                :value="
                  (column.resetKey && item[column.resetKey.value]) || item.value
                "
                :disabled="column.optionsDisableKey && column.optionsDisableValue.includes(item[column.optionsDisableKey])"
              />
            </el-select>
          </template>
          <!-- 级联下拉 -->
          <el-cascader
            v-else-if="column.type === 'cascader'"
            v-model="scope.row[column.prop]"
            :options="column.options"
            :clearable="column.clearable || true"
            :filterable="column.filterable || true"
            :multiple="column.multiple || false"
            :props="column.propsData || { expandTrigger: 'hover' }"
            :placeholder="column.placeholder || '请输入内容'"
            :disabled="column.disabled"
            :collapse-tags="column.collapseTags"
            @change="
              (val) => {
                return changeValue(val, scope, column);
              }
            "
          ></el-cascader>
          <template v-else-if="column.type === 'select2'">
            <el-select
              :multiple="column.multiple"
              :collapse-tags="column.collapseTags"
              v-model="scope.row[column.prop]"
              :clearable="!!column.clearable"
              :filterable="!!column.filterable"
              :placeholder="column.placeholder || '请选择'"
              :remote="column.remote || false"
              :remote-method="column.remote_method"
              @visible-change="(val) => visibleChange(val, scope, column)"
              @change="
                (val) => {
                  return changeValue(val, scope, column);
                }
              "
            >
              <el-option
                v-for="(item, index) in scope.row[column.options]"
                :key="index"
                :label="
                  (column.resetKey && item[column.resetKey.label]) || item.label
                "
                :value="
                  (column.resetKey && item[column.resetKey.value]) || item.value
                "
              />
            </el-select>
          </template>
          <template v-else-if="column.type === 'popoverSpan'">
            <el-popover
              placement="top-start"
              :key="index"
              width="420"
              trigger="click"
            >
              <span>{{ scope.row[column.prop] }}</span>
              <el-button v-if="scope.row[column.prop]" class="m-r-8" slot="reference" type="text">
                {{ column.label }}
              </el-button>
            </el-popover>
          </template>
          <template v-else-if="column.type === 'tooltip'">
            <div style="width: 100px;">
              <el-tooltip
                style="width: 100px;"
                effect="dark"
                placement="top"
                v-if="scope.row[column.tooltipKey]"
              >
                <div slot="content" style="width: 300px;">
                  {{ scope.row[column.tooltipKey] }}
                </div>
                <div style="width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                  <span>{{ scope.row[column.prop] }}</span>
                </div>
              </el-tooltip>
              <div v-else style="width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                <span>{{ scope.row[column.prop] }}</span>
              </div>
            </div>
          </template>
<!--          todo 暂时这个先写成独特的，后期如有其他需要考虑写成通用-->
          <template v-else-if="column.type === 'tooltip_async'">
              <async-tooltip :request="() => column.method(scope.row.id)">
                  <span>{{ scope.row[column.prop] }}</span>
              </async-tooltip>
          </template>
          <template v-else-if="column.type === 'tooltip_link'">
              <el-tooltip
                effect="dark"
                placement="top"
                v-if="scope.row[column.tooltipKey]"
              >
                <div slot="content">
                  {{ scope.row[column.tooltipKey] }}
                </div>
                <div
                  class="cursor"
                  style="font-size: 14px;font-weight: 500;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
                  :class="
                    checkPermission(column.stop, $route.meta.buttonCodes)
                      ? 'main-color1'
                      : 'disabled-color'
                  "
                  @click="
                    checkPermission(column.stop, $route.meta.buttonCodes)
                      ? handleLinkClick(scope)
                      : ''
                  "
                >
                  {{ scope.row[column.prop] }}
                </div>
              </el-tooltip>
              <div v-else style="width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">
                <span>{{ scope.row[column.prop] }}</span>
              </div>
          </template>
          <template v-else-if="column.type === 'actions' && checkPermission(column.code, $route.meta.buttonCodes)" >
            <template v-for="(item, index) in column.options">
              <template v-if="checkAccount(item.account) && handleShow(item.show, scope.row)">
              <template v-if="item.type && item.type === 'render'">
                <template
                  v-if="checkPermission(item.code, $route.meta.buttonCodes) "
                >
                  <el-button
                    type="text"
                    :key="index + 'i'"
                    @click="handleActions(item, scope)"
                    :disabled="handleDisabled(item.disabled, scope.row)"
                    :class="item.color"
                  >
                    {{
                      (column.resetKey && item[column.resetKey.label]) ||
                      item.name
                    }}
                  </el-button>
                </template>
              </template>
              <template v-else-if="item.type && item.type === 'switch'">
                <!-- v-if="checkPermission(item.code, $route.meta.buttonCodes)" -->
                <el-switch
                  v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                  :key="index"
                  :value="scope.row[item.key]"
                  @change="handleActions(item, scope)"
                >
                </el-switch>
              </template>
              <template v-else-if="item.type && item.type === 'popoverImage'">
                <el-popover
                  v-if="isInclude(item, scope.row)"
                  placement="top-start"
                  :key="index"
                  width="120"
                  trigger="click"
                >
                  <el-image
                    style="width: 100px; height: 100px"
                    fit
                    :previewSrcList="[scope.row[item.image]]"
                    :src="scope.row[item.image]"
                  ></el-image>
                  <el-button class="m-r-8" slot="reference" type="text"
                    >{{ item.name }}
                  </el-button>
                </el-popover>
              </template>
<!--            发票指定工厂    -->
              <template v-else-if="item.type && item.type === 'popoverRemoteSelect'">
                <el-popover
                    placement="top-start"
                    width="220"
                    :key ="index"
                    trigger="click">
                  <el-select
                      style="width: 200px"
                      v-model="item.prop"
                      filterable
                      remote
                      :remote-method="item.remote_method"
                      @change=" (val) => changeValue(val, scope, column)">
                    <el-option
                        v-for="(itemByOptions, index) in item.options"
                        :key="index"
                        :label="(item.resetKey && itemByOptions[item.resetKey.label]) || itemByOptions.label"
                        :value="(item.resetKey && itemByOptions[item.resetKey.value]) || itemByOptions.value"/>
                  </el-select>
                  <el-button class="m-l-10" slot="reference" type="text">{{ item.name }}</el-button>
                </el-popover>
              </template>
              <template v-else-if="item.type && item.type === 'popover'">
                <template v-if="item.zy && item.zy === 'fpmx'">
                  <el-popover
                    placement="top-start"
                    :title="item.title"
                    :key="index"
                    width="200"
                    trigger="click"
                    v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                  >
                    <div v-if="fpmx.infos && fpmx.infos.length > 0">
                      <div
                        style="color: #333"
                        v-for="(item, index) in fpmx.infos"
                        :key="item + index"
                      >
                        {{ item.ivCode }}：{{ item.amount }}
                      </div>
                    </div>
                    <div style="color: #333">
                      未分配金额：{{ fpmx.unAllocatedAmount }}
                    </div>
                    <span
                      class="cursor"
                      slot="reference"
                      type="text"
                      :class="item.color"
                      :disabled="handleDisabled(item.disabled, scope.row)"
                      @click="handleActions(item, scope)"
                    >
                      {{
                        (column.resetKey && item[column.resetKey.label]) ||
                        item.name
                      }}</span
                    >
                  </el-popover>
                </template>
                <template v-else-if="item.zy && item.zy === 'fpmxshd'">
                  <el-popover
                    v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                    placement="top-start"
                    :title="item.title"
                    :key="index + 'asdasdas'"
                    width="200"
                    trigger="click"
                  >
                    <div
                      style="color: #333"
                      v-for="(rfg, hq) in fpmxshd.infos"
                      :key="hq + 'jhjkjnjkj'"
                    >
                      {{ rfg.ivCode }}：{{ rfg.amount }}
                    </div>
                    <div style="color: #333">
                      未分配金额：{{ fpmxshd.unAllocatedAmount }}
                    </div>
                    <div
                      class="cursor"
                      slot="reference"
                      type="text"
                      @click="handleActions(item, scope)"
                      :disabled="handleDisabled(item.disabled, scope.row)"
                      :class="item.color"
                    >
                      <span
                        class="cursor"
                        style="display: block"
                        type="text"
                        :class="item.color"
                        v-if="scope.row.allocatedAmount > 0"
                      >
                        {{ scope.row.allocatedAmount }}</span
                      >
                      <span class="cursor" type="text" :class="item.color">
                        {{
                          (column.resetKey && item[column.resetKey.label]) ||
                          item.name
                        }}</span
                      >
                    </div>
                  </el-popover>
                </template>
                <template v-else-if="item.key">
                  <el-popover
                    v-if="
                      isInclude(item, scope.row) &&
                      checkPermission(item.code, $route.meta.buttonCodes)
                    "
                    placement="top-start"
                    :title="item.title"
                    :key="index"
                    width="200"
                    trigger="click"
                    :content="scope.row[item.content]"
                  >
                    <span
                      class="cursor"
                      slot="reference"
                      type="text"
                      :class="item.color"
                    >
                      {{
                        (column.resetKey && item[column.resetKey.label]) ||
                        item.name
                      }}</span
                    >
                  </el-popover>
                </template>
                <template v-else-if="item.key1">
                  <!-- <template v-if="isIncludeKey1(item, scope.row)"> -->
                  <el-popover
                    v-if="
                      isIncludeKey1(item, scope.row) &&
                      checkPermission(item.code, $route.meta.buttonCodes)
                    "
                    placement="top-start"
                    :title="item.title"
                    :key="index"
                    width="200"
                    trigger="click"
                    :content="scope.row[item.content]"
                  >
                    <span
                      class="cursor"
                      slot="reference"
                      type="text"
                      :class="item.color"
                    >
                      {{
                        (column.resetKey && item[column.resetKey.label]) ||
                        item.name
                      }}</span
                    >
                  </el-popover>
                </template>
                <template v-else>
                  <el-popover
                    v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                    placement="top-start"
                    :title="item.title"
                    :key="index"
                    width="200"
                    trigger="click"
                    :content="scope.row[item.content]"
                  >
                    <span
                      class="cursor"
                      slot="reference"
                      type="text"
                      :class="item.color"
                    >
                      {{
                        (column.resetKey && item[column.resetKey.label]) ||
                        item.name
                      }}</span
                    >
                  </el-popover>
                </template>
              </template>
              <template v-else-if="item.type && item.type === 'more'">
                <!--    v-if="checkPermission(item.code, $route.meta.buttonCodes)" -->
                <el-dropdown
                    v-if="(!item.showKey1 || item.showKey1Value.includes(scope.row[item.showKey1]))
                            && (!item.showKey2 || item.showKey2Value === scope.row[item.showKey2])"
                  trigger="click"
                  @command="
                    (command) => {
                      return handleActions(command, scope);
                    }
                  "
                  :key="index + 'k'"
                >
                  <span class="el-dropdown-link main-color m-l-15 cursor">
                    {{ item.name
                    }}<i class="el-icon-arrow-down el-icon--right"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <div v-for="(down, k) in getActions(item)" :key="k">
                      <template v-if="checkAccount(down.account)" >
                      <template
                        v-if="
                          down.key &&
                          isInclude(down, scope.row) &&
                          checkPermission(down.code, $route.meta.buttonCodes)
                        "
                      >
                        <el-dropdown-item :command="down"
                          >{{ down.name }}
                        </el-dropdown-item>
                      </template>
                      <template v-else-if="down.key1">
                        <el-dropdown-item
                          v-if="
                            isIncludeKey1(down, scope.row) &&
                            checkPermission(down.code, $route.meta.buttonCodes)
                          "
                          :command="down"
                          >{{ down.name }}
                        </el-dropdown-item>
                      </template>
                      <template v-else-if="down.type === 'upload'">
                        <el-dropdown-item
                          command="handleUpload"
                          v-if="
                            checkPermission(down.code, $route.meta.buttonCodes)
                          "
                        >
                          <el-upload
                            class="upload-demo"
                            action="#"
                            :http-request="
                              (val) => handleUpload(val, down, scope)
                            "
                            :multiple="down.multiple"
                            :show-file-list="false"
                          >
                            {{ down.name }}
                          </el-upload>
                        </el-dropdown-item>
                      </template>
                      <template v-else-if="!down.key">
                        <el-dropdown-item
                          :command="down"
                          v-if="
                            checkPermission(down.code, $route.meta.buttonCodes)
                          "
                          >{{ down.name }}
                        </el-dropdown-item>
                      </template>
                      </template>
                    </div>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
              <template v-else-if="item.type && item.type === 'delete'">
                <el-popconfirm
                  :key="index + 'i'"
                  title="确定要删除吗？"
                  @confirm="handleActions(item, scope)"
                  v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                >
                  <el-button
                    class="color-red m-l-8 m-r-8"
                    slot="reference"
                    type="text"
                    >删除
                  </el-button>
                </el-popconfirm>
              </template>
              <template v-else-if="item.type && item.type === 'text'">
                <span
                  v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                  :key="index + 'i'"
                  >{{
                    scope.row[item.prop] === 0 ? 0 : scope.row[item.prop] || ""
                  }}
                </span>
              </template>
              <template v-else-if="item.type && item.type === 'textLine'">
                <div
                  v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                  :key="index + 'i'"
                >
                  {{
                    scope.row[item.prop] === 0 ? 0 : scope.row[item.prop] || ""
                  }}
                </div>
              </template>
              <template v-else-if="item.type && item.type === 'valueButton'">
                <el-button
                  v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                  type="text"
                  :key="index + 'i'"
                  @click="handleActions(item, scope)"
                  :disabled="handleDisabled(item.disabled, scope.row)"
                  :class="item.color"
                >
                  {{
                    scope.row[item.prop] === 0 ? 0 : scope.row[item.prop] || ""
                  }}
                </el-button>
              </template>
              <template v-else-if="item.type && item.type === 'upload'">
                <el-upload
                  v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                  :key="index + 'i'"
                  class="upload m-l-8 m-r-8"
                  action="#"
                  :http-request="(val) => handleUpload(val, item, scope)"
                  :multiple="item.multiple"
                  :show-file-list="false"
                >
                  <el-button :class="item.color" type="text"
                    >{{ item.name }}
                  </el-button>
                </el-upload>
              </template>
              <template v-else-if="item.key">
                <template
                  v-if="
                    isInclude(item, scope.row) &&
                    checkPermission(item.code, $route.meta.buttonCodes)
                  "
                >
                  <el-button
                    v-if="!item.type || item.type !== 'none'"
                    type="text"
                    :key="index + 'i'"
                    @click="handleActions(item, scope)"
                    :disabled="handleDisabled(item.disabled, scope.row)"
                    :class="item.color"
                  >
                    {{
                      (column.resetKey && item[column.resetKey.label]) ||
                      scope.row[item.prop] ||
                      item.name
                    }}
                  </el-button>
                  <span style="width: 100%" :key="index + 'i'" v-else>
                    {{
                      (column.resetKey && item[column.resetKey.label]) ||
                      item.name
                    }}
                  </span>
                </template>
              </template>
              <template v-else-if="item.nokey">
                <template
                  v-if="
                    scope.row[item.nokey] !== item.value &&
                    checkPermission(item.code, $route.meta.buttonCodes)
                  "
                >
                  <el-button
                    v-if="!item.type || item.type !== 'none'"
                    type="text"
                    :key="index + 'i'"
                    @click="handleActions(item, scope)"
                    :disabled="handleDisabled(item.disabled, scope.row)"
                    :class="item.color"
                  >
                    {{
                      (column.resetKey && item[column.resetKey.label]) ||
                      item.name
                    }}
                  </el-button>
                  <span style="width: 100%" :key="index + 'i'" v-else>
                    {{
                      (column.resetKey && item[column.resetKey.label]) ||
                      item.name
                    }}
                  </span>
                </template>
              </template>
               <template v-else-if="item.type && item.type === 'multipleConditionsShow'">
                <template
                  v-if="
                    scope.row[item.showKey1] === item.showKey1Value &&
                    scope.row[item.showKey2] === item.showKey2Value &&
                    checkPermission(item.code, $route.meta.buttonCodes)
                  "
                >
                  <el-button
                    v-if="!item.type || item.type !== 'none'"
                    type="text"
                    :key="index + 'i'"
                    @click="handleActions(item, scope)"
                    :disabled="handleDisabled(item.disabled, scope.row)"
                    :class="item.color"
                  >
                    {{
                      item.name
                    }}
                  </el-button>
                  <span style="width: 100%" :key="index + 'i'" v-else>
                    {{
                      item.name
                    }}
                  </span>
                </template>
              </template>
              <template v-else-if="item.key1">
                <template
                  v-if="
                    isIncludeKey2(item, scope.row) &&
                    checkPermission(item.code, $route.meta.buttonCodes)
                  "
                >
                  <el-button
                    v-if="!item.type || item.type !== 'none'"
                    type="text"
                    :key="index + 'i'"
                    @click="handleActions(item, scope)"
                    :disabled="handleDisabled(item.disabled, scope.row)"
                    :class="item.color"
                  >
                    {{
                      (column.resetKey && item[column.resetKey.label]) ||
                      item.name
                    }}
                  </el-button>
                  <span style="width: 100%" :key="index + 'i'" v-else>
                    {{
                      (column.resetKey && item[column.resetKey.label]) ||
                      item.name
                    }}
                  </span>
                </template>
              </template>
              <template v-else>
                <template
                  v-if="checkPermission(item.code, $route.meta.buttonCodes)"
                >
                  <el-button
                    type="text"
                    :key="index + 'i'"
                    @click="handleActions(item, scope)"
                    :disabled="handleDisabled(item.disabled, scope.row)"
                    :class="item.color"
                  >
                    {{
                      (column.resetKey && item[column.resetKey.label]) ||
                      item.name
                    }}
                  </el-button>
                </template>
              </template>
              </template>
            </template>
          </template>
          <template v-else-if="column.type === 'checked'">
            <i
              :class="
                scope.row[column.prop] === true
                  ? 'el-icon-success main-color'
                  : 'el-icon-remove'
              "
            ></i>
          </template>
          <template v-else-if="column.type === 'light'">
            <i
              class="icon-zhuangtaideng iconfont"
              :class="scope.row[column.prop] === 1 ? 'color-green' : 'color-ae'"
            ></i>
          </template>
          <!-- 日期选择-->
          <template v-else-if="column.type === 'dayselect'">
            <el-date-picker
              v-model="scope.row[column.prop]"
              style="width: 140px"
              type="date"
              :value-format="scope.row.format"
              placeholder="Please select"
            >
            </el-date-picker>
          </template>
          <template v-else-if="column.type === 'datetime'">
            <el-date-picker
              v-model="scope.row[column.prop]"
              type="datetime"
              :value-format="column.format || 'yyyy-MM-dd HH:mm:ss'"
              :placeholder="'请选择'"
              format="yyyy-MM-dd HH:mm:ss"
            >
            </el-date-picker>
          </template>
          <template v-else-if="column.type === 'remark'">
            <i
              class="el-icon-edit"
              slot="reference"
              style="color: #409eff"
              @click="showAddRemark(scope.row, column)"
            ></i>
            <span>{{ scope.row[column.prop] }}</span>
          </template>
          <template v-else-if="column.type === 'icon_edit'">
            <i
              :class="column.icon"
              slot="reference"
              style="color: #409eff"
              class="cursor"
              @click="handleActions(column, scope)"
            ></i>
            <span>{{ scope.row[column.prop] }}</span>
          </template>
          <!-- <template v-else-if="column.type === 'icon_edit_delete'"> -->
          <template v-else-if="column.type === 'icon_edit_noValue'">
            <span v-if="column.textViewKey2  && column.textViewValues2.includes(scope.row[column.textViewKey2])">{{scope.row[column.prop]}}</span>
            <span v-else-if="column.textViewKey  && column.textViewValues.includes(scope.row[column.textViewKey])">{{scope.row[column.prop]}}</span>
            <el-select
                 v-else
                :multiple="column.multiple"
                :collapse-tags="column.collapseTags"
                v-model="scope.row[column.prop]"
                :clearable="!!column.clearable"
                :filterable="!!column.filterable"
                :placeholder="column.placeholder || '请选择'"
                :remote="column.remote || false"
                :remote-method="column.remote_method"
                @visible-change="(val) => visibleChange(val, scope, column)"
                :loading="scope.row[column.loading]"
                loading-text="加载中"
                @change="
                (val) => {
                  return changeValue(val, scope, column);
                }
              "
            >
              <el-option
                  v-for="(item, index) in column.options"
                  :key="index"
                  :label="
                  (column.resetKey && item[column.resetKey.label]) || item.label
                "
                  :value="
                  (column.resetKey && item[column.resetKey.value]) || item.value
                "
              />
            </el-select>
            <i
                v-if="scope.row[column.unrecognize] !== column.value"
                :class="column.icon"
                slot="reference"
                style="color: #409eff"
                class="cursor"
                @click="handleActions(column, scope)"
            ></i>
            <template v-if="scope.row[column.key] && scope.row[column.key].includes(column.whetherDeleteValue)">
              <el-popconfirm
                  :key="index + 'i'"
                  title="确定要删除吗？"
                  @confirm="handleActionsDelete(column, scope)"
              >
                <i
                    v-if="scope.row[column.prop] !== '' && scope.row[column.unrecognize] !== column.value"
                    slot="reference"
                    class="cursor color-red m-l-8 el-icon-delete"
                ></i>
              </el-popconfirm>
            </template>
          </template>
          <template v-else-if="column.type === 'selectOrShow'">
            <el-select
                v-if="scope.row[column.selectOrShow]"
                :multiple="column.multiple"
                :collapse-tags="column.collapseTags"
                v-model="scope.row[column.prop]"
                :clearable="!!column.clearable"
                :filterable="!!column.filterable"
                :placeholder="column.placeholder || '请选择'"
                :remote="column.remote || false"
                :remote-method="column.remote_method"
                :loading="scope.row[column.loading]"
                loading-text="加载中"
                @visible-change="(val) => visibleChange(val, scope, column)"
                @change="
                (val) => {
                  return changeValue(val, scope, column);
                }
              "
            >
              <el-option
                  v-for="(item, index) in column.options"
                  :key="index"
                  :label="
                  (column.resetKey && item[column.resetKey.label]) || item.label
                "
                  :value="
                  (column.resetKey && item[column.resetKey.value]) || item.value
                "
                  :disabled="item.disabled"
              />
            </el-select>
            <span v-else>{{ scope.row[column.prop] }}</span>
          </template>

          <template v-else-if="column.type === 'icon_delete'">
            <el-popconfirm
              :key="index + 'i'"
              title="确定要删除吗？"
              @confirm="handleActions(column, scope)"
            >
              <i
                v-if="scope.row[column.prop] !== ''"
                :class="column.icon"
                slot="reference"
                class="cursor color-red m-l-8"
              ></i>
            </el-popconfirm>
            <span>{{ scope.row[column.prop] }}</span>
          </template>
          <span v-else-if="column.type === 'number'">
            {{
              Number(scope.row[column.prop]).toFixed(column.toFixed)
            }}
          </span>
          <template v-else-if="column.type === 'productNumber'">
            <span
              v-if="scope.row[column.prop] !== null && String(scope.row[column.prop]).trim() !== ''"
              class="product-number-link"
              @click="$emit('productNumberClick', { row: scope.row, column })"
            >
              {{ scope.row[column.prop] }}
            </span>
            <span v-else>
              {{ scope.row[column.prop] === 0 ? 0 : scope.row[column.prop] || "" }}
            </span>
          </template>
          <span v-else>
            {{
              scope.row[column.prop] === 0
                ? 0
                : scope.row[column.prop] === "null" ||
                  scope.row[column.prop] === "undefined"
                ? ""
                : scope.row[column.prop] || ""
            }}
          </span>
        </template>
      </el-table-column>
      </template>
      <slot name="other"></slot>
    </el-table>
    <!--    添加备注-->
    <el-dialog
      title="添加备注"
      :visible.sync="show_remark"
      :append-to-body="true"
    >
      <el-input
        type="textarea"
        :maxlength="remark_length"
        v-model="remark"
      ></el-input>
      <div slot="footer">
        <el-button @click="show_remark = false">取消</el-button>
        <el-button type="primary" @click="changeRemark">确定</el-button>
      </div>
    </el-dialog>
<!--    下载贴标资料-->
    <el-dialog
        title="下载贴标资料"
        :visible.sync="show_label_info"
        :append-to-body="true"
    >
      <el-switch
          v-model="switch_value"
          active-text="下载且改变状态"
          inactive-text="纯下载"
          :disabled="switch_disabled">
      </el-switch>
      <div slot="footer">
        <el-button type="primary" @click="downloadAllLabelInfo">下载全部贴标资料</el-button>
        <el-button @click="cancelDownloadLabelInfo">取消</el-button>
        <el-button type="primary" :disabled="switch_disabled"  @click="downloadLabelInfo">执行</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import checkPermission from "@/utils/permission_btn";
import {UserModule} from "@/store/modules/user";
import {deepClone} from "@/utils/deepClone";
import AsyncTooltip from "@/components/AsyncTooltip/index.vue";
import {hasMoreThanTwoDecimals} from "@/utils/number";

export default {
  name: "BaseTable",
  components: {AsyncTooltip},
  props: {
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    /**
     * prop：键值
     * label：名称
     */
    columns: {
      type: Array,
      default() {
        return [];
      },
    },
    nullShowLine: {
      type: Boolean,
      default: false
    },
    slots: {
      type: Boolean,
      default: false,
    },
    show1: {
      type: Boolean,
      default: false,
    },
    show2: {
      type: Boolean,
      default: false,
    },
    show3: {
      type: Boolean,
      default: false,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    judge_check: {
      type: Boolean,
      default: false,
    },
    rowClassAction: {
      type: String,
      default: "",
    },
    arraySpanAction: {
      type: String,
      default: "",
    },
    span_key: {
      type: String,
      default: "",
    },
    firstIndex: {
      type: Boolean,
      default: false,
    },
    firstIndexOne: {
      type: Boolean,
      default: false,
    },
    opename: {
      type: String,
      default: "操作",
    },
    height: {
      type: String,
      default: "500",
    },
    minHeight: {
      type: String,
      default: "500px",
    },
    maxHeight: {
      type: [String, Number],
      default: null,
    },
    border: {
      type: Boolean,
      default: true,
    },
    slotWidth: {
      type: Number,
      default: 25,
    },
    width: {
      type: Number,
    },
    typeClass: {
      type: String,
    },
    tableKey: {
      type: Number,
      default: Math.random(),
    },
    showSummary: {
      type: Boolean,
      default: false,
    },
    setSummaries: {
      type: Function,
      default: () => {
        return {};
      },
    },
    fpmx: {
      type: Object,
      default: () => {
        return {};
      },
    },
    fpmxshd: {
      type: Object,
      default: () => {
        return { infos: [] };
      },
    },
    loading: {
      type: Boolean,
      default: false,
    },
    sortable: {
      type: [String, Boolean],
      default: false,
    },
    // 斑马纹
    stripe: {
      type: Boolean,
      default: true,
    },
    header_style: {
      type: Object,
      default: () => {
        return {};
      },
    },
    row_style: {
      type: Boolean,
      default: true,
    },
    // 结算单位的类型  1 中国  2 日本
    country_type: {
      type: Number,
      default: 2,
    },
    reserveSelection: {
      type: Boolean,
      default: true,
    },
    rowKey: {
      type: String,
      default: "",
    },
    selectedRowsOBJ: {
      type: Object,
      default: () => {
        return {};
      },
    },
    pageNumber: {
      type: Number,
      default: 1,
    },
    otherTxt: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      tableMaxHeight: null,
      // 合并单元格需要的数据
      spanArr: [], // 遍历数据时，根据相同的标识去存储记录
      pos: 0, // 二维数组的索引
      table_columns: [],
      show_remark: false,
      remark: null,
      remark_click: null,
      remark_prop: null,
      remark_length: 50,
      row: null,
      noTooltipList:['discount','price_hint','input','inputNumber','inputNumberSelect','select','select2','cascader','tooltip','tooltip_link','invoiceCode'], // 不使用tooltip的列
      noResizable: ['tooltip','tooltip_link'],// 不能拉伸的列
      show_label_info:false,
      switch_value:false,
      switch_disabled:false,
    };
  },
  watch: {
    tableData: {
      handler(v) {
        let wrap = document.getElementsByClassName("el-table__body-wrapper");
        if (wrap) {
          wrap[0].scrollTop = 0;
        }
      },
    },
    // selectRows: {
    //   handler() {
    //     this.toggleSelection(this.selectRows);
    //   }
    // }
  },
  filters: {
    filterlistStatus(val, list) {
      let obj = list.find((v) => v.id == val);
      if (obj) {
        return obj.name;
      } else {
        return "";
      }
    },
    filterlistDisabled(val, list) {
      let obj = list.find((v) => v.id == val);
      return obj.name;
    },
  },
  mounted() {
    // this.setMaxHeight();
    // window.onresize = () => {
    //     this.setMaxHeight();
    // };
  },
  methods: {
    hasMoreThanTwoDecimals,
    checkPermission,
    getNumberLimit(primary, row, prop, fallback) {
      if (primary !== undefined && primary !== null) {
        return primary;
      }
      if (prop && row && row[prop] !== undefined && row[prop] !== null) {
        return row[prop];
      }
      return fallback;
    },
    // 上传
    handleUpload(file, down, row) {
      this.$emit(down.click, {
        file,
        item: row.row,
      });
    },
    getToolTip(column) {
      return this.noTooltipList.findIndex((item) => item === column.type) === -1?true:false
    },
    toggleSelection() {
      console.log("这里走了", this.selectedRowsOBJ[`index${this.pageNumber}`]);
      if (
        this.selectedRowsOBJ[`index${this.pageNumber}`] &&
        this.selectedRowsOBJ[`index${this.pageNumber}`].length > 0
      ) {
        console.log("这里也走了");
        this.selectedRowsOBJ[`index${this.pageNumber}`].forEach((row) => {
          this.$nextTick(() => {
            this.tableData.find((obj) => {
              if (row.detailId === obj.detailId) {
                this.$refs.table.toggleRowSelection(obj, true);
              }
            });
          });
        });
      }
      // if (this.selectRows && this.selectRows.length > 0) {
      //   console.log('这里也走了',this.selectRows)
      //   this.selectRows.forEach(row => {
      //     this.$refs.table.toggleRowSelection(row);
      //   });
      // }
    },
    showAddRemark(row, column) {
      this.row = row;
      this.remark = column.prop !== "remark" ? row[column.prop] : row.remark;
      this.remark_click = column.click;
      this.remark_length = column.length ? column.length : 50;
      this.remark_prop = column.prop;
      this.show_remark = true;
    },
    showDownloadLabelInfo(row, column) {
      if (!this.canClickDownloadLabelInfo(row, column)) {
        return;
      }
      this.row = row;
      this.show_label_info = true;
      if (row.row.downloadedLabelInfo) {
        this.switch_disabled = true;
      }
    },
    canClickDownloadLabelInfo(scope, column) {
      // 这里由于包装部需要可以下载更新。所以这里移除掉【不需要打】、【线下提供】不能点击的处理
      if (scope.row[column.disabled_key] === '不需要打' || scope.row[column.disabled_key] === '线下提供') {
        return true;
      }
      if (scope.row[column.disabled_key2] !== column.disabled_value2) {
        return  column.disabled_value.indexOf(scope.row[column.disabled_key]) === -1;
      } else {
        return false;
      }
    },
    getType(val, list) {
      let obj = list.find((v) => v.id === val);
      if (obj) {
        return obj.type;
      } else {
        return "";
      }
    },
    getColumns(columns) {
      let table_columns = [];
      table_columns = columns.filter((item) => {
        // item.show && !item.show_key || (item.show_key && this[item.show_key]);
        return !item.show_key || (item.show_key && this[item.show_key]);
      });
      return table_columns;
    },
    setMaxHeight() {
      let dom = this.$refs.table;
      if (dom) {
        this.tableMaxHeight = document.body.clientHeight - dom.$el.offsetTop;
      }
      this.tableMaxHeight = this.tableMaxHeight - 10; // 页面内边距 TableContent
      this.tableMaxHeight = this.tableMaxHeight - 50; // 分页高度
      this.tableMaxHeight = this.tableMaxHeight - 80; // 底部foot高度
      if (this.showSummary) {
        this.tableMaxHeight = this.tableMaxHeight + 46; // 如果有总计的高度加46px
      }
      if (this.tableMaxHeight < 200) {
        // 最小的table最大高度为200
        this.tableMaxHeight = 200;
      }
    },
    getActions(item) {
      let list = [];
      item.actions.map((val) => {
        list.push(val);
      });
      return list;
    },
    isIncludeKey1(item, row) {
      if (row[item.key2]) {
        return (
          row[item.key2].indexOf(item.value2) > -1 &&
          (row[item.key1] === item.value1 || (typeof row[item.key1] === 'boolean' ?[row[item.key1]].indexOf(item.value1) > -1:row[item.key1].indexOf(item.value1) > -1))
        );
      } else {
        return false;
      }
    },
    isIncludeKey2(item, row) {
      if (row[item.key2]) {
        return (
          item.value2.indexOf(row[item.key2]) > -1 &&
          (row[item.key1] === item.value1 || item.value1.indexOf(row[item.key1]) > -1)
        );
      } else {
        return false;
      }
    },
    isInclude(item, row) {
      if (item.key === "type_str") {
        return row[item.key].indexOf(item.value) > -1;
      }
      if (item.key === "boolean_str") {
        if (row[item.value]) {
          return true;
        } else {
          return false;
        }
        // return row[item.value].indexOf(row[item.value]) > -1;
      }
      if (typeof item.value === "boolean") {
        return item.value === row[item.key];
      } else {
        return item.value.indexOf(row[item.key]) > -1;
      }
    },
    handleLinkClick(row,clickFun) {
      if (clickFun) {
        this.$emit(clickFun, row);
      }else {
        this.$emit("linkClick", row);
      }
    },
    changeValue(val, row, column) {
      this.$emit("selectChange", { val, row, column });
    },
    visibleChange(val, row, column) {
      this.$emit("visibleChange", {val, row, column});
    },
    changeRemark() {
      this.$emit(this.remark_click || "handleRemark", {
        ...this.row,
        remark: this.remark,
      });
      this.remark = null;
      this.remark_click = null;
      this.show_remark = false;
    },
    downloadLabelInfo() {
      let state = this.switch_value;
      this.$emit("downloadLabelInfo", {
        ...this.row,
        changeState: state
      });
      this.cancelDownloadLabelInfo();
    },
     downloadAllLabelInfo() {
      this.$emit("downloadAllLabelInfo", {
        ...this.row,
      });
    },
    cancelDownloadLabelInfo() {
      this.show_label_info = false;
      this.switch_disabled = false;
      this.switch_value = false;
    },
    handleSelectAll(column) {
      const allMatch = this.tableData.every(item => item.specialMarks === true);
      this.tableData.forEach((item) => item[column.prop] = !allMatch);
    },
    changeInputValue(val, row, column) {
      if(val === '') {
        if(row.row.type && row.row.type === 'PACKING'){

        }else{
          if(column.type === 'inputNumber' || column.type === 'inputNumberSelect') {
            this.$emit("inputChange", { val, row, column });
          } else {
            this.$notify({
              title: "提示",
              message: "请不要输入为空",
              type: "warning"
            });
          }
        }
      } else {
        this.$emit("inputChange", { val, row, column });
      }
    },
    isMultipleOf(value, step) {
      const v = Number(value);
      const s = Number(step);
      if (!Number.isFinite(v) || !Number.isFinite(s) || s <= 0) return true;
      const ratio = v / s;
      return Math.abs(ratio - Math.round(ratio)) < 1e-8;
    },
    shouldShowMultipleOfWarning(row, column) {
      if (!column.multipleOfProp) return false;
      const value = row[column.prop];
      const step = row[column.multipleOfProp];
      if (value === '' || value == null || step === '' || step == null) return false;
      return !this.isMultipleOf(value, step);
    },
    getMultipleOfWarningContent(row, column) {
      if (typeof column.multipleOfWarning === 'function') {
        return column.multipleOfWarning(row);
      }
      return column.multipleOfWarning || '';
    },
    shouldShowQuantityStepWarning(row, column) {
      if (!column.quantityStepProp) return false;
      const step = Number(row[column.quantityStepProp]);
      return Number.isFinite(step) && step > 1;
    },
    getTooltipContent(row, column) {
      if (typeof column.tooltipContent === 'function') {
        return column.tooltipContent(row);
      }
      return column.tooltipContent || '';
    },

    handleSpecLinkClick(scope, col) {
      this.$emit(col.click, scope);
    },
    handleFunNameClick(fun, scope) {
      this.$emit(fun, scope);
    },
    handleActions(item, scope) {
      this.$emit(item.click, scope);
    },
    handleActionsDelete(item,scope) {
      this.$emit(item.deleteClick, scope);
    },
    handleSelect(data) {
      this.$emit("returnData", data);
    },
    // 双击栏目
    dblclick(row, column, event) {
      this.$emit("dblclick", { row, column, event });
    },
    tagList(list, value) {
      let data = list.filter((v) => {
        return value.indexOf(v.id) > -1;
      });
      return data || [];
    },
    sortChange(data) {
      this.$emit("sortChange", data);
    },
    handleSelectionChange(row) {
      this.$emit("handleSelectionChange", row);
    },
    handleSelectionChangeOne(selection,row) {
      this.$emit("handleSelectionChangeOne", selection);
      this.$emit("handleSelectionChangeTwo", { selection,row });
    },
    handleSelectionChangeAll(row) {
      this.$emit("handleSelectionChangeAll", row);
    },
    checkSelectable(row) {
      if (this.judge_check) {
        return row.selectable;
      }
      return true;
    },
    tableRowClassName({ row, rowIndex }) {
      if (!this.rowClassAction) {
        return "";
      }
      return this[this.rowClassAction]({ row, rowIndex });
    },
    rowClassForDV({ row, rowIndex }) {
      // if(row.checkResultCode) {
      //   if(row.checkResultCode === 1){
      //     return 'error-row'
      //   } else if (row.checkResultCode === 2) {
      //     return 'warning-row'
      //   }
      // }
      if(row.checkResultCode === 1){
          return 'error-row'
        } else if (row.checkResultCode === 2) {
          return 'warning-row'
        }
    },
    rowClassForDD({ row, rowIndex }) {
      if(row.abnormal){
        return 'error-row'
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (!this.arraySpanAction) {
        return "";
      }
      return this[this.arraySpanAction]({ row, column, rowIndex, columnIndex });
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] += "";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    projectSpanAction({ rowIndex, columnIndex }) {
      // 页面列表上 表格合并行 -> 第几列(从0开始)
      // 需要合并多个单元格时 依次增加判断条件即可
      if (
        columnIndex !== 11 &&
        columnIndex !== 12 &&
        columnIndex !== 13 &&
        columnIndex !== 14 &&
        columnIndex !== 15
      ) {
        // 二维数组存储的数据 取出
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      } else {
        return false;
      }
    },
    contractSpanAction({ row, column, rowIndex, columnIndex }) {
      // 页面列表上 表格合并行 -> 第几列(从0开始)
      // 需要合并多个单元格时 依次增加判断条件即可
      if (
        columnIndex !== 8 &&
        columnIndex !== 9 &&
        columnIndex !== 10 &&
        columnIndex !== 11 &&
        columnIndex !== 12 &&
        columnIndex !== 13
      ) {
        // 二维数组存储的数据 取出
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      } else {
        return false;
      }
    },

    handleShow(show,row){
      if (show){
        if (typeof show === 'string'){
          return Boolean.parse(show);
        }
        if (typeof show === 'boolean'){
          return show;
        }
        if (typeof show === 'function'){
          return show(row);
        }
      }
      return true;
    },

    handleDisabled(disabled, row) {
      if (disabled) {
        if (typeof disabled === "boolean") {
          return disabled;
        }
        if (typeof disabled === "function") {
          return disabled(row);
        }
      }
      return false;
    },

    checkAccount(exceptAccounts) {
      if (exceptAccounts) {
        const userAccounts = UserModule.accountType
        if (exceptAccounts instanceof Array) {
          return userAccounts.some(a => {
            return exceptAccounts.includes(a)
          })
        }
        if (exceptAccounts instanceof String) {
          return userAccounts.some(a => {
            return exceptAccounts == a
          })
        }
      }
      return true;
    },

    clearSelection(){
      this.$refs.table.clearSelection()
    }
  },
};
</script>
<style>
.el-table .warning-row {
  background: #E6A23C !important;
}
.el-table .error-row {
  background: #F56C6C !important;
}
.el-table .success-row {
  background: #abd98d !important;
}
.input-multiple-of-warning {
  color: #F56C6C;
  cursor: pointer;
  font-size: 16px;
  line-height: 32px;
}
.discount-quantity-step-cell {
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
}
.discount-quantity-step-cell .input-multiple-of-warning {
  margin-left: 4px;
  line-height: 1;
}
.quantity-step-warning-content {
  white-space: pre-line;
  max-width: 280px;
  line-height: 1.5;
}
</style>
<style lang="scss" scoped>
.classMargin {
  line-height: 26px;
}

.statusButton {
  color: #333;
  text-align: left;
  padding: 0;

  // 点
  .point {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 100%;
    vertical-align: middle;
    margin-right: 2px;
  }

  // 颜色
  .bRed {
    background: #e02020;
  }

  .bGray {
    background: #999999;
  }

  .bGreen {
    background: #67c23a;
  }

  .bOrange {
    background: #f68812;
  }

  .fontbRed {
    color: #e02020;
  }

  .fontbGray {
    color: #999999;
  }

  .fontbGreen {
    color: #67c23a;
  }

  .fontbOrange {
    color: #f68812;
  }

  // .bBlue {
  // }
  // .bYellow {
  // }
  // .bPurple {
  // }
}

::v-deep {
  .el-input-number {
    width: 100% !important;
  }

  .el-input__inner {
    padding: 0 5px;
    text-align: center;
  }

  .el-table .cell.el-tooltip {
    width: auto !important;
  }

  .el-table th.el-table__cell > .cell {
    padding: 0 0px;
    font-size: 12px;
  }
}

.icon {
  position: absolute;
  left: 0;
  top: 0;
}
.right-top {
  position: absolute;
  top: 0;
  right: 0; /* 将图标放置在容器的右上角 */
}
.content-bottom {
  position: absolute;
  bottom: 0; /* 将内容放在底部 */
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  text-align: center;
  line-height: 1;
}

// ::v-deep .el-table .cell.el-tooltip {
//     white-space: normal !important;
// }

.product-number-link {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}

.upload {
  display: inline-block;
}

::v-deep .el-form-item__error {
  margin-top: -6px;
  padding: 0;
}
</style>
